// Actualiza los precios del upsell según la variante seleccionada.
if (!customElements.get('floopy-offer-prices')) {
  customElements.define(
    'floopy-offer-prices',
    class extends HTMLElement {
      connectedCallback() {
        this.select = this.closest('floopy-drawer-offer')
          ?.querySelector('select');

        this.update = () => {
          const option = this.select?.selectedOptions[0];
          if (!option) return;

          const price = this.querySelector('[data-offer-price]');
          const comparison = this.querySelector('[data-offer-compare]');

          if (price) {
            price.textContent = option.dataset.price || '';
          }

          if (comparison) {
            comparison.textContent = option.dataset.compare || '';
            comparison.hidden = !option.dataset.compare;
          }
        };

        this.select?.addEventListener('change', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.update);
      }
    }
  );
}